import { divisionColors, LOCAL_STORAGE_ITEMS } from '../constants/constants';

export const getAcronym = (text) => {
  const arr = text.split(' ');
  const arr2 = arr.map((item) => item.charAt(0).toUpperCase());
  return arr2.join('');
};

export const getDivisionClass = (division) =>
  divisionColors[division.toLowerCase()] || divisionColors.default;

export const hasPermission = (permissionName) => {
  const permissions = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_ITEMS.USER_PERMISSIONS)
  );
  return permissions && permissions.includes(permissionName);
};
